const en = {
  somethingWentWrong: "Sorry Something Went Wrong Please Try Again Later",

  login: "Login",
  loginId: "Login ID",
  password: "Password",

  users: "Users",
  name: "Name",
  phoneNumber: "Phone Number",
  userId: "User ID",
  email: "Email",
  idNumber: "Number ID",
  submit: "Submit",
  createUser: "Create User",
  registeredAt: "Registered At",
  days: "Days",
  gym: "Gym",
  swim: "Swim",

  dailyReport: "Daily Report",
  advancedDailyReport: "Advance Daily Report",
  orders: "Orders",
  admin: "Admin",
  logout: "Logout",

  admins: "Admins",
  center: "Centers",
  packages: "Packages",

  id: "ID",
  createdAt: "Created At",
  type: "Type",
  features: "Features",

  duration: "Duration",
  price: "Price",
  discount: "Discount",
  englishName: "English Name",
  kurdishName: "Kurdish Name",
  arabicName: "Arabic Name",
  showType: "Show Type",
  firstTime: "First Time",
  afterFirstTime: "After First Time",
  allTime: "All Time",

  owner: "Owner",
  manager: "Manager",
  trainer: "Trainer",
  reception: "Reception",

  distributionWithTrainer: "Distribution With Trainer",
  notDistributionWithTrainer: "Not Distribution With Trainer",

  divideBenefit: "Divide Benefit",
  requestCourse: "Courses",
  cafeteria: "Cafeteria",
  cafeteriaBenefit: "Cafeteria Benefit",
  expenses: "Expenses",
  cafeteriaExpenses: "Cafeteria Expenses",
  totalCafeteriaExpenses: 'Total Cafeteria Expenses',
  gymExpenses: "Gym Expenses",
  date: "Date",

  endDate: "End Date",

  supplements: "Supplements",

  newUser: "New User",
  renewSubscription: "Renew Subscription",
  membershipBenefit: "Membership Benefit",
  reportSummary: "Summary of Report",
  advancedReportSummary: "Advanced Report Summary",
  revenue: "Revenue",
  profit: "Profit",
  membershipSummary: "Membership Summary",
  financeSummary: "Finance Summary",
  main: "Main",

  numberOrder: "Order Num.",
  dashboard: "Dashboard",

  memberships: "Memberships",
  activeUser: "Active User",
  expiredUser: "Expired User",
  startDate: "Start Date",
  start: "Start",
  end: "End",
  day: "Day",
  username: "Username",
  ticketNumber: "Ticket Number",

  offerType: "Offer Type",
  receptionDivideBenefit: "Distribution amount with receipt",
  normal: "Normal",
  offer: "Offer",

  delete: "Delete",

  undefined: "Undefined",
  male: "Male",
  female: "Female",
  gender: "Gender",

  openingTheDoors: "Opening the doors",
  door: "Door",
  reason: "Reason",
  employeeComing: "Employee Coming",

  wholesalePrice: "Wholesale price",
  minimumSalePrice: "Minimum Sale Price",
  buyPrice: "Buy Price",

  balance: "Balance",

  numberOfGuestUsers: "Number Of Guest Users",
  sellPrice: "Sell Price",
  realPrice: "Real Price",

  numberOfProductInStore: "Number of products in stock",

  buy: "Buy",
  returnOfPurchase: "Return of Purchase",
  image: "Image",
  select: "Select",
  sellId: "Sell ID",
  note: "Note",
  customers: "Customers",
  debt: "Debt",
  repaymentOfDebt: "Repayment Of Debt",
  sell: "Sell",
  freeWallet: "Free Wallet",
  money: "Money",
  payedPrice: "Payed Price",
  totalPrice: "Total Price",
  productNumber: "Product Number",
  totalPreviousDebts: "Total previous debts",
  totalDebts: "Total Debts",
  quantity: "Quantity",
  qty: 'Qty.',
  print: "Print",
  equipments: "Equipments",
  shippingCars: "Shipping Cars",
  brands: "Brands",
  totalPayedPrice: "Total Payed Price",
  remainingDebts: "Remaining Debts",
  brand: "Brand",
  code: "Code",
  salary: "Salary",
  stock: "Stock",
  cleaner: "Cleaner",
  accountant: "Accountant",
  proteinSeller: "Protein Seller",
  socialMedia: "Social Media",
  technical: "Technical",
  expense: "Expense",
  cafeteriaGuestUser: "Cafeteria Guest User",
  totalSalary: "Total Salary",
  garage: "Garage",
  supplementExpenses: "Supplements Expenses",
  bigExpenses: "Big Expenses",
  package: "Package",
  insertLogoToImage: "Insert Logo To Image",
  proteinManager: "Protein Manager",
  equipmentManager: "Equipment Manager",
  stockBenefitPrice: "قازانجی کۆگا (نرخی تاک)",
  stockBenefitWholePrice: "قازانجی کۆگا (نرخی کۆ)",
  stockBenefitBuyPrice: "کۆی کۆگا (نرخی کڕین)",

  benefitPrice: "قازانج (نرخی تاک)",
  BenefitWholePrice: "قازانج (نرخی کۆ)",

  live: "Live",
  purchasesHistory: "History of Purchases",
  balancesHistory: "History of Balances",
  usersFeedback: "Feedbacks",
  starRate: "Stars",
  feedback: "Feedback",
  newSubscribers: "New Subscribers",
  renewalOfSubscriptions: "Renewal of Subscriptions",
  dollarPrice: "Dollar Price",
  proteinStock: 'Protein Stock',
  receiptsOfPayment: "Receipts Of Payment",
  retailPrice: 'Retail Price',
  subs: 'Subs',
  subject: 'Subject',
  part: 'Part',
  recipients: 'Recipients',
  receipts: 'Receipts',
  customs: 'Customs',
  carNumber: 'Car Number',
  cost: 'Cost',
  expense_1: 'Expense',
  creatingTransition: 'Creating a Transition',
  centers: 'Centers',
  administration: 'Administration',
  brandImage: 'Brand Image',
  categories: 'Categories',
  jobOpportunities: 'Job Opportunities',
  cvs: 'CVs',
  location: 'Location',
  position: 'Position',
  revenueByBenefitPrice: 'Revenue By (Sell Price - Buy Price)',
  revenueByItems: 'Revenue by product sold',
  revenueByBuyPrice: 'Revenue by product sold',
  profitWithoutExpenses: 'Profit without expense',
  publicDebt: 'Public Debt',
  ratio: 'Ratio',
  profitAtRetailPrice: 'Profit at retail price',
  profitAtWholeSalePrice: 'Profit At Wholesale Price',
  gymReception: 'Gym Reception',
  cafeteriaReception: 'Cafeteria Reception',
  gymCoach: 'Gym Coach',
  monthlyReport: 'Monthly Report',
  normalCourseProfit: 'Normal Course Profit',
  VIPCourseProfit: 'VIP Course Profit',
  cafeteriaProfit: 'Cafeteria Profit',
  publicProfitAfterMamAzad: 'Public Profit After Mam Azad',
  publicProfit: 'Public Profit',
  coursesReport: 'Courses Report',
  save: 'Save',
  loading: 'Loading',
  equipmentStock: 'Equipment Stock',
  licenses: 'Licenses',
  'attendance-time': 'Attendance Time',
  childrenNannies: 'Children Nannies',
  accountantOfAnotherCompany: 'Accountant Of Another Company',
  asudaCity: 'Asuda City',
  'asudaCity$': 'Asuda City $',
  paroshTowers: 'Parosh Towers',
  'paroshTowers$': 'Parosh Towers $',
  slavaCity: 'Slava City',
  'slavaCity$': 'Slava City $',
  mamAzad: 'Mam Azad',
  'mamAzad$': 'Mam Azad $',
  miniSlavaMen: 'MiniSlava Men',
  'miniSlavaMen$': 'MiniSlava Men $',
  miniSlavaWomen: 'MiniSlava Women',
  'miniSlavaWomen$': 'MiniSlavaWomen $',
  lifeTowers: 'Life Towers',
  'lifeTowers$': 'Life Towers $',
  akaFitnessProfit: 'Aka Fitness Profit',
  akaFitnessProfit$: 'Aka Fitness Profit $',
  finalProfit: 'Final Profit',
  'price-lists': 'Price Lists',
  'select-item': 'Select Item',
  cancel: 'Cancel',
  repaymentOfDebtAkaPower: 'Repayment Of Debt (AkaPower)',
  debtsAkaPower: 'Debts (AkaPower)',
  swimmingItems: 'Swimming Items',
  akaFitnessSupplementsProfit: 'Aka Fitness Supplement Profit',
  asudaSupplementsProfit: 'Asuda Supplement Profit',
  finalPrice: 'Final Price',
  totalRepaymentOfDebt: 'Total Repayment Of Debt',
  totalPayedPriceFromSells: 'Total Payed Price From Sells',
  'revenue(repaymentOfDebt,payedPrice)': 'Revenue (Repayment of Debt, Payed Price)',
  ratioByDebt: 'Ratio By Debt',
  ratioBySupplement: 'Ratio By Supplements',
  ratioByMoney: 'Ratio By Money',
  ratioType: 'Ratio Type',
  totalMoneyReceived: 'Total Money Received',
  totalAvailableMoney: 'Total Available Money',
  reportSummaryNew: 'Report Summary New',
  gyms: 'Gyms',

  currentMonth: 'Current Month',
  lastMonthByThisTime: 'Last Month By This Time',
  lastMonth: 'Last Month',
  allOfThem: 'All Of Them 💥',
  trainers: 'Trainers',
  thereIsNoDataToDisplay: 'There is no data to display',
  sellSupplements: 'Sell Supplements',
  deleteMembership: 'Delete Memberships',

  'areYouSureYouWantToDeleteThisExpense?': 'Are you sure you want to delete this expense?',
  deletionOfExpenses: 'Deletion of expenses',
  'areYouSureAboutDeleting?': 'Are you sure about deleting?',
  totalPriceOfRegularCourses: 'Total Price Of Regular Courses',
  'totalPriceOfVIPCourses': 'Total price of VIP courses',
  numOfNormalCourses: 'Num Of Normal Courses',
  numOfVIPCourses: 'Num Of VIP Courses',
  'trainerProfitsFromRegularCourses': 'Trainer profits from regular courses',
  'trainerProfitsFromVIPCourses': 'Trainer profits from VIP courses',
  akaFitnessProfitFromRegularCourses: 'Aka Fitness profit from regular courses',
  'akaFitnessProfitsFromVIPCourses': 'Aka Fitness profits from VIP courses',
  coachGrossProfit: 'Coach gross profit',
  grossProfitAkaFitness: 'Gross Profit Aka Fitness',
  num: 'Num.',
  nameOfTheEmployee: 'Name of the employee',
  fixedSalary: 'Fixed Salary',
  courseRatio: 'Course Ratio',
  supplementRatio: 'Supplement Ratio',
  numOfSupplements: 'Num Of Supplements',
  totalPriceOfSupplements: 'Total Price Of Supplements',
  'trainerProfit15%': 'Trainer Profit 15%',
  theDollarIsGenerallyCalculatedAt: 'The dollar is generally calculated at',
  courseReportSummary: 'Course Report Summary',
  salariesOfEmployees: 'Salaries of employees {{price}}',
  summaryOfTheDietarySupplementReport: 'Summary of the Dietary Supplement Report',
  cafeteriaSalesReportSummary: 'Cafeteria Sales Report Summary',
  totalOfProductsWereSoldAtPriceOfDinars: 'A total of {{qty}} products were sold at a price of {{price}} dinars',
  salaryNotSpecified: 'Salary not specified',
  dateNotSpecified: 'Date not specified',
  salaryByDate: 'Salary by date',

  increasedExpenses: 'Increased expenses',
  updateOfExpenses: 'Update of expenses',
  byPrice: 'by',

  courseWriting: 'Course writing',
  courseUpdate: 'Course update',
  changeOfParticipation: 'Change of participation',

  sellingOfSupplements: 'Selling of supplements',
  updateOfSellingSupplements: 'Update of selling supplements',
  purchaseBalance: 'Purchase balance',
  changeOfBalance: 'Change of Balance',
  openingTheDoor: 'Opening the door',
  becauseOf: 'Because of',
  saleOfCafeteriaProducts: 'Sale of cafeteria products',

  star: 'Star',
  in: 'in',
  for: 'for',
  total: 'Total',
  search: 'Search',

  receptionDivideBenefitIQD: 'Reception divide benefit IQD',

  numOfMemberships: 'Num Of Memberships',
  numOfThreeMonth: 'Num Of Three Month Memberships',
  numOfSixMonth: 'Num Of Six Month Memberships',
  totalPriceOfThreeMonths: 'Total Price Of Three Months',
  totalPriceOfSixMonths: 'Total Price Of Six Months',
  receptionRatioOfThreeMonths: 'Reception Ratio Of Three Months',
  receptionRatioOfSixMonths: 'Reception Ratio Of Six Months',
  akaFitnessDivideBenefitIQD: 'Aka Fitness Divide Benefit IQD',

  receptionReportSummary: 'Reception Report Summary',
  receptionsRatio: 'Receptions Ratio',
  'thereWere{{update}}UpdatesAnd{{new}}NewSubscribersInTheReportGenerated': 'There Were {{update}} Updates And {{new}} New Subscribers In The Report Generated',
  membershipsRatio: 'Memberships Ratio',
  cafeExpense: 'Cafe Expense',
  gymExpense: 'Gym Expense',
  bigExpense: 'Big Expense',

  by: 'By',
  expiredUsers: 'Expired Users',
  'writeDownTheReasonForOpeningTheDoor': 'Write down the reason for opening the door',
  open: 'Open',
  numOfDay: '{{num}} Day',
  'areYouSureAboutExecutingTheAction': 'Are you sure about executing the action?',
  youCannotChangeProducts: 'You cannot change products',
  youCannotChangeProducts1: 'You cannot change the product if you entered it incorrectly. Please return the product and then register a new one',
  player: 'Player',
  returnSupplementsProductToMainStorage: 'Return Supplements Product To Main Storage',
  others: 'Others',
  playersFromOtherHalls: 'Players from other halls',
  dollar: 'Dollar',
  iqd: 'IQD',
  renew: 'Renew',
  userNotFoundPleaseVerifyID: 'User not found Please verify ID',
  noUser: 'No User',
  printLastMembership: 'Print Last Membership',
  addBalance: 'Add Balance',
  updateFaceId: 'Update Face ID',
  updateCurrentPackage: 'Update Current Package',
  advancePurchase: 'Advance Purchase',
  resetMobileAccount: 'Reset Mobile Account',
  doYouWantToRegisterFace: 'Do you want to register face?',
  sendRequest: 'Send Request',
  deleteTheLastSubscriptionAndExpireIt: 'Delete the last subscription and expire it',
  problemsWithTheParticipantsBalance: 'Problems with the participant\'s balance',
  problemsWithFaceRecognition: 'Problems with face recognition',
  lastSubscriptionNotIncludedInDailyReport: 'Last subscription not included in daily report',
  problemsWithMobileAccounts: 'Problems with mobile accounts',
  suggestedRequest: 'Suggested Request',
  orCustomRequest: 'OR Custom Request',
  moreDetails: 'More Details',
  request: 'Request',
  orSuggestedRequest: 'OR Suggested Request',
  duplicateName: 'Duplicate Name',
  theSameMemberHasMultipleAccounts: 'The same Member has multiple accounts',
  transferOfParticipation: 'Transfer of participation',
  send: 'Send',
  changeTrainerName: 'Change Trainer Name',
  changeCoursePrice: 'Change Course Price',
  deleteCourse: 'Delete Course',
  deleteExpense: 'Delete Expense',
  changeSupplementPrice: 'Change Supplement Price',
  revenueType: 'Revenue Type',
  vipLocker: 'VIP Locker',
  salon: 'Salon',
  deleteRevenue: 'Delete Revenue',
  otherRevenue: 'Other Revenue',
  timesLeft: 'Times Left',
  openDoor: 'Open Door',
  returnSupplement: 'Return Supplement',
  'areYouSureYouWantToResetYourMobileAccount?': 'Are you sure you want to reset your mobile account?',
  'areYouSureYouWantUpdateFaceID?': 'Are you sure you want update face ID?',
  'areYouSureYouWantOpenDoor?': 'Are you sure you want open door?',
  requests: 'Requests',
  pendingRequests: 'Pending Requests',
  status: 'Status',
  pending: 'Pending',
  accepted: 'Accepted',
  rejected: 'Rejected',
  cash: 'Cash',
  makeItFree: 'Make It Free 😕 !',
  free: 'Free',
  requestedCourse: 'Requested Course',
  captain: 'Captain',
  updateFaceIdOf: 'Update Face ID Of',
  "Gym Door": "Gym Door",
  "Main Door": "Main Door",
  "Swim Door": "Swim Door",
  lastMembership: 'Last Membership',
  addSwimmingItem:'Add Swimming Item',
  systemStatusNormal: 'System Status Normal',
  systemStatus: 'System Status',
  akaPowerMainServer: 'Aka Power Main Server',
  faceRecognitionMachine:'Face Recognition Machine',
  abnormal: 'Abnormal',
  cafeCard: 'Cafe Card',
  userNotSaveInFaceMachinePleaseTryAgain: 'User not save in face machine please try again',
  payedType: 'Payed Type',
  payedTypeMessage:'Please ask the customer if he pays in dollars or dinars?',
  coach: 'Coach',
  profile:'Profile',
  amountOfPaymentByCustomer: 'Amount of payment by customer',
  "physicalTherapy": "Physical Therapy",
  aFullHourPhysicalTherapySessionForPartBody: "A full hour physical therapy session for part body",
  fullBodyMessageOneHour: "Full body massage for one hour",
  fourPhysicalTherapy: "Four physical therapy sessions or part of the body",
  addPhysicalTherapy: "Add Physical Therapy",
  userName: "User Name",
  update: "Update",
  "expiryDate": "Expiry Date",
  "lastMembershipDate": "Last Membership Date",
  birthDate: "Birth Date",
  receipt: "Receipt",
  available: "Available",
  usd: "USD",
  dinar: "Dinar",
  swimmingSales: "Swimming Sales",
  nutritionSales: "Nutrition Sales",
  nutrition: "Nutrition",
  cafeteriaCash: "Cafeteria Cash",
  "cafeteria-card": "Cafeteria Card",
  discountForEmployees15: "Discount for employees 15%",
};


export default en